module.exports = __webpack_public_path__ + "static/media/Character Generator.a87d4ee9.png";